import { render, staticRenderFns } from "./ResultsPlaceholderV2.vue?vue&type=template&id=6dd61b80"
import script from "./ResultsPlaceholderV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultsPlaceholderV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResultsPlaceholderV2.vue?vue&type=style&index=0&id=6dd61b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseContainer: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseContainer.vue').default,BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
